module.exports = __webpack_public_path__ + "static/media/trainingIconHover.9bcbd723.svg";